module.exports = __webpack_public_path__ + "static/media/TUNE_4374.b4a25580.jpg";